import request from '@/util/request' 
import api from '@/util/api';
export async function getCardInfo():Promise<any>{
    return await request.http({
        url:api.getCardInfo
    })
}